import { render, staticRenderFns } from "./StatusDaAvaliacao.vue?vue&type=template&id=71bfd290&"
import script from "./StatusDaAvaliacao.vue?vue&type=script&lang=js&"
export * from "./StatusDaAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports